var p = Object.defineProperty;
var u = (e, a, t) => a in e ? p(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var i = (e, a, t) => u(e, typeof a != "symbol" ? a + "" : a, t);
import { HttpClient as o, httpClient as r } from "../../httpClient.js";
class c extends o {
  constructor() {
    super(...arguments);
    i(this, "evaluation", "/transcript-evaluation");
    i(this, "evaluations", "/transcript-evaluations");
    i(this, "transcripts", "/transcripts");
  }
  getEvaluation() {
    return r.get(this.evaluation);
  }
  updatePersonalInfo(t) {
    return r.put(`${this.evaluation}/personal-info`, t);
  }
  updateAcademicInfo(t) {
    return r.put(`${this.evaluation}/academic-info`, t);
  }
  evaluateFile(t) {
    return r.post(`${this.transcripts}/evaluate`, t, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 12e4
    });
  }
  addFileTranscript(t) {
    return r.post(`${this.transcripts}/file`, t);
  }
  addManualTranscript(t) {
    return r.post(`${this.transcripts}/manual`, t);
  }
  updateTranscript(t, s) {
    return r.put(`${this.transcripts}/${t}`, s);
  }
  updateTranscriptDetails(t, s) {
    return r.put(`${this.transcripts}/${t}/details`, s);
  }
  listTranscripts() {
    return r.get(this.transcripts);
  }
  deleteTranscript(t) {
    return r.delete(`${this.transcripts}/${t}`);
  }
  markTranscriptReady(t) {
    return r.post(`${this.transcripts}/${t}/ready`);
  }
  listEvaluations(t) {
    return r.get(this.evaluations, {
      params: t
    });
  }
  getEvaluationAdmin(t) {
    return r.get(`${this.evaluations}/${t}`);
  }
  reviewTranscript(t, s) {
    return r.post(`${this.transcripts}/${t}/review`, s);
  }
  saveTranscriptProgress(t, s) {
    return r.put(`${this.transcripts}/${t}/progress`, s);
  }
  adminAddTranscript(t, s) {
    return r.post(
      `${this.evaluations}/${t}/transcripts`,
      s
    );
  }
  validateTranscript(t, s) {
    return r.post(
      `${this.transcripts}/${t}/validate`,
      s,
      { headers: { "Content-Type": "multipart/form-data" }, timeout: 12e4 }
    );
  }
  replaceTranscriptCourses(t, s) {
    return r.put(`${this.transcripts}/${t}/courses`, s);
  }
  reorderTranscriptCourses(t, s) {
    return r.put(`${this.transcripts}/${t}/courses/order`, s);
  }
  processTranscriptFile(t, s, n) {
    return r.post(
      `${this.transcripts}/${t}/files/${s}/process`,
      n ?? {}
    );
  }
}
const d = new c();
export {
  d as default
};
